(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-how-it-works';
  var STEP_CLASS = 'oddit-section-how-it-works__step';
  var OPEN_CLASS = 'oddit-section-how-it-works__step--current';
  var HEADER_SELECTOR = '.oddit-section-how-it-works__header';

  // Accordion is mobile/tablet only; on desktop every step is shown at once.
  var accordionMq = window.matchMedia('(max-width: 989px)');

  function steps(section) {
    return Array.prototype.slice.call(
      section.querySelectorAll('.' + STEP_CLASS)
    );
  }

  function openStep(section, target) {
    steps(section).forEach(function (step) {
      var header = step.querySelector(HEADER_SELECTOR);
      var isOpen = step === target;
      step.classList.toggle(OPEN_CLASS, isOpen);
      if (header) {
        header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    });
  }

  function expandAll(section) {
    // Desktop: all panels are visible, so reflect that in ARIA.
    steps(section).forEach(function (step) {
      var header = step.querySelector(HEADER_SELECTOR);
      if (header) header.setAttribute('aria-expanded', 'true');
    });
  }

  function currentOpen(section) {
    return section.querySelector('.' + OPEN_CLASS) || steps(section)[0];
  }

  function applyMode(section) {
    if (accordionMq.matches) {
      openStep(section, currentOpen(section));
    } else {
      expandAll(section);
    }
  }

  function initSection(section) {
    var list = steps(section);
    if (!list.length) return;

    list.forEach(function (step) {
      var header = step.querySelector(HEADER_SELECTOR);
      if (!header) return;

      header.addEventListener('click', function () {
        if (!accordionMq.matches) return; // desktop: no toggling
        // Keep exactly one step open at a time; clicking the open one is a no-op.
        if (step.classList.contains(OPEN_CLASS)) return;
        openStep(section, step);
      });
    });

    applyMode(section);

    var onChange = function () {
      applyMode(section);
    };
    if (accordionMq.addEventListener) {
      accordionMq.addEventListener('change', onChange);
    } else if (accordionMq.addListener) {
      accordionMq.addListener(onChange);
    }
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
